import _t from 'i18n!bundles/videojs/layout/nls/resolutionMenuSection';
import $ from 'jquery';
import videojs from 'video.js';

import resolutionMenuSectionTemplate from 'bundles/videojs/layout/resolutionMenuSection.html';
import 'bundles/videojs/plugins/resolutions';

class ResolutionMenuSection extends videojs.getComponent('MenuItem') {
  constructor(player, options) {
    super(player, options);

    player.on('resolutionchange', this.updateResolutionText.bind(this));

    this.one(player, 'ready', function () {
      $(this.el_).find('[data-js="decrease-resolution-button"]').click(player.decreaseResolution.bind(player));
      $(this.el_).find('[data-js="increase-resolution-button"]').click(player.increaseResolution.bind(player));

      this.updateResolutionText();
    });
  }

  createEl(type, props) {
    return $(resolutionMenuSectionTemplate())[0];
  }

  updateResolutionText() {
    const resolution = this.player_.resolution();
    const resolutionText = this.resolutionNames_[resolution] || resolution;

    $(this.el_).find('[data-js="resolution-text"]').text(resolutionText);
  }

  options_ = {
    name: 'resolutionMenuSection',
  };

  resolutionNames_ = {
    '240p': _t('Lowest'),
    '360p': _t('Low'),
    '540p': _t('Medium'),
    '720p': _t('High'),
    '1080p': _t('Highest'),
  };
}

videojs.registerComponent('ResolutionMenuSection', ResolutionMenuSection);
